/**
 * @generated SignedSource<<606d4e69c61505141a8d872b1a5a9639>>
 * @relayHash 5a90594763d7a8673f65ec8c7e849b6a
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 47f01d1d48f57dd836d1f3ac63ea3b0a31a6e9bb6d8c35820ba433bf6887adac

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventsScreenListPaginationQuery$variables = {
  count?: number | null | undefined;
  cursor?: string | null | undefined;
};
export type EventsScreenListPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EventsScreenList_query">;
};
export type EventsScreenListPaginationQuery = {
  response: EventsScreenListPaginationQuery$data;
  variables: EventsScreenListPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "and": [
        {
          "not": {
            "metadata": {
              "containsKey": "meetupEventID"
            }
          }
        },
        {
          "allowGlobalListing": {
            "equalTo": true
          }
        }
      ]
    }
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "timeSelection",
    "value": "UPCOMING"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v8 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v9 = {
  "kind": "Literal",
  "name": "fit",
  "value": "cover"
},
v10 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v11 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "membershipLevel",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v8/*: any*/),
            (v9/*: any*/),
            {
              "kind": "Literal",
              "name": "fo",
              "value": "face"
            },
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"face\",\"h\":100,\"w\":100})"
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v8/*: any*/),
        (v10/*: any*/),
        (v11/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "transform"
    }
  ],
  "kind": "ScalarField",
  "name": "defaultAvatarUrl",
  "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"h\":100,\"w\":100})"
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v20 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v6/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v4/*: any*/)
],
v21 = [
  (v19/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventsScreenListPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          }
        ],
        "kind": "FragmentSpread",
        "name": "EventsScreenList_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventsScreenListPaginationQuery",
    "selections": [
      {
        "alias": "upcomingEvents",
        "args": (v1/*: any*/),
        "concreteType": "EventsConnection",
        "kind": "LinkedField",
        "name": "eventsByTimeSelection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EventsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startAt",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "prettyUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasExternalUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasVenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "visibility",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "coverPhoto",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": "mobileTransformUrl",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "transform",
                            "value": {
                              "dpr": 3,
                              "w": 576
                            }
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "transformUrl",
                        "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":576})"
                      },
                      {
                        "alias": "desktopTransformUrl",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "transform",
                            "value": {
                              "dpr": 3,
                              "w": 200
                            }
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "transformUrl",
                        "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":200})"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "eventOwner",
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "primaryPhoto",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "fields": [
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v11/*: any*/)
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "transform"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "transformUrl",
                                "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "colorPalette",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GuildMembership",
                            "kind": "LinkedField",
                            "name": "myMembership",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "type": "Guild",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isMe",
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/)
                        ],
                        "type": "User",
                        "abstractKey": null
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "attendeesByRelevance",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "status": {
                            "in": [
                              "ATTENDING_IN_PERSON",
                              "ATTENDING_VIRTUAL",
                              "WAITING_IN_PERSON",
                              "WAITING_VIRTUAL"
                            ]
                          }
                        }
                      },
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 8
                      }
                    ],
                    "concreteType": "EventAttendeesConnection",
                    "kind": "LinkedField",
                    "name": "eventAttendeesByRelevance",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventAttendeesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventAttendee",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": (v20/*: any*/),
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:8)"
                  },
                  {
                    "alias": "attendingCount",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "status": {
                            "in": [
                              "ATTENDING_IN_PERSON",
                              "ATTENDING_VIRTUAL"
                            ]
                          }
                        }
                      }
                    ],
                    "concreteType": "EventAttendeesConnection",
                    "kind": "LinkedField",
                    "name": "eventAttendees",
                    "plural": false,
                    "selections": (v21/*: any*/),
                    "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
                  },
                  {
                    "alias": "waitingCount",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "status": {
                            "in": [
                              "WAITING_IN_PERSON",
                              "WAITING_VIRTUAL"
                            ]
                          }
                        }
                      }
                    ],
                    "concreteType": "EventAttendeesConnection",
                    "kind": "LinkedField",
                    "name": "eventAttendees",
                    "plural": false,
                    "selections": (v21/*: any*/),
                    "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "SORT_ORDER_ASC",
                          "CREATED_AT_ASC"
                        ]
                      }
                    ],
                    "concreteType": "EventTicketingTiersConnection",
                    "kind": "LinkedField",
                    "name": "eventTicketingTiers",
                    "plural": false,
                    "selections": (v21/*: any*/),
                    "storageKey": "eventTicketingTiers(orderBy:[\"SORT_ORDER_ASC\",\"CREATED_AT_ASC\"])"
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventAttendee",
                    "kind": "LinkedField",
                    "name": "myAttendance",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "visibleStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "paymentStatus",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GuildMembership",
                            "kind": "LinkedField",
                            "name": "myMembership",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "status",
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "Guild",
                        "abstractKey": null
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Form",
                    "kind": "LinkedField",
                    "name": "attendeeForm",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": "eventItemPresentations",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "CREATED_AT_ASC",
                          "ID_ASC"
                        ]
                      }
                    ],
                    "concreteType": "PresentationsConnection",
                    "kind": "LinkedField",
                    "name": "presentations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PresentationsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Presentation",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "presenterFirstName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "presenterLastName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "presenter",
                                "plural": false,
                                "selections": (v20/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "transform",
                                    "value": {
                                      "dpr": 3,
                                      "h": 24,
                                      "w": 24
                                    }
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "guestPresenterAvatarUrl",
                                "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"h\":24,\"w\":24})"
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "presentations(orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "upcomingEvents",
        "args": (v1/*: any*/),
        "filters": [
          "timeSelection",
          "filter"
        ],
        "handle": "connection",
        "key": "EventsScreenList_query_upcomingEvents",
        "kind": "LinkedHandle",
        "name": "eventsByTimeSelection"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "authorizationLevel",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "47f01d1d48f57dd836d1f3ac63ea3b0a31a6e9bb6d8c35820ba433bf6887adac",
    "metadata": {},
    "name": "EventsScreenListPaginationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "68c90724d9eff827c624e32d6c519096";

export default node;
